import {Flex, Input, Text} from '@priority-software/priority-style-react';
import React, {useEffect, useRef, useState} from 'react';
import styles from '../styles.module.scss';
import {getCardPicByType} from '../utils';
import {procClientContinue} from '../../../_shared/GWTBridge/invoke/procMain';
import {Footer} from './Footer';

export const CreditCardForm = ({
    total,
    setIsLoading,
    setIsSuccess,
    setIsSubmitted,
    isSubmitted,
    setIsError,
    token
}) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobile, setMobile] = useState('');
    const [zip, setZip] = useState('');
    const [email, setEmail] = useState('');
    const [isCcnValid, setIsCcnValid] = useState(false);
    const [isCvvValid, setIsCvvValid] = useState(false);
    const [isExpValid, setIsExpValid] = useState(false);
    const [ccnStatus, setCcnStatus] = useState('');
    const [cvvStatus, setCvvStatus] = useState('');
    const [expStatus, setExpStatus] = useState('');
    const [cardType, setCardType] = useState('');
    const isPayment = useRef(total !== '0');

    const isPaymentButtonDisabled = () => {
        return (
            !firstName ||
            !lastName ||
            !zip ||
            !email ||
            !isCcnValid ||
            !isCvvValid ||
            !isExpValid ||
            isSubmitted
        );
    };

    const createHostedPaymentFields = () => {
        const bsObj = {
            token: token,
            onFieldEventHandler: {
                onError: function (tagId, errorCode, errorDescription) {
                    switch (tagId) {
                        case 'ccn':
                            setCcnStatus(errorDescription);
                            setIsCcnValid(false);
                            break;
                        case 'cvv':
                            setCvvStatus(errorDescription);
                            setIsCvvValid(false);
                            break;
                        case 'exp':
                            setExpStatus(errorDescription);
                            setIsExpValid(false);
                            break;
                        default:
                            break;
                    }
                    //* TODO: do we want to log the errors? */

                    // console.log('error code: ' + errorCode);
                    // console.log('tagId: ' + tagId);
                }, // Handle a change in validation
                onType: function (tagId, cardType, cardData) {
                    /* cardType will give card type, and only applies to ccn: AMEX, VISA, MASTERCARD, AMEX, DISCOVER, DINERS, JCB */
                    setCardType(cardType);
                },
                onEnter: function (tagId) {}, // Will trigger when shopper presses enter while inside one of the inputs

                onValid: function (tagId) {
                    switch (tagId) {
                        case 'ccn':
                            setCcnStatus('');
                            setIsCcnValid(true);
                            break;
                        case 'cvv':
                            setCvvStatus('');
                            setIsCvvValid(true);
                            break;
                        case 'exp':
                            setExpStatus('');
                            setIsExpValid(true);
                            break;
                        default:
                            break;
                    }
                } // Handle a change in validation
            },
            style: {
                input: {
                    //style for all input elements
                    padding: '0 10px'
                },
                '::placeholder': {
                    color: '#B2BCC6',
                    opacity: '1' /* Firefox */
                }
            },
            ccnPlaceHolder: '',
            cvvPlaceHolder: '***',
            expPlaceHolder: 'MM/YY'
        };

        //Run the following command after Document Object Model (DOM) is fully loaded
        (window as any).bluesnap.hostedPaymentFieldsCreate(bsObj);
    };

    useEffect(() => {
        createHostedPaymentFields();
    }, []);

    const submitPayment = () => {
        setIsSubmitted(true);
        (window as any).bluesnap.hostedPaymentFieldsSubmitData(function (callback) {
            if (null != callback.cardData) {
                // const fraudSessionId = callback.transactionFraudInfo.fraudSessionId;

                // console.log(
                //     'card type: ' +
                //         callback.cardData.ccType +
                //         ', last 4 digits: ' +
                //         callback.cardData.last4Digits +
                //         ', exp: ' +
                //         callback.cardData.exp +
                //         ', issuing Country: ' +
                //         callback.cardData.issuingCountry +
                //         ', isRegulatedCard: ' +
                //         callback.cardData.isRegulatedCard +
                //         ', cardSubType: ' +
                //         callback.cardData.cardSubType +
                //         ', binCategory: ' +
                //         callback.cardData.binCategory +
                //         ', cardCategory: ' +
                //         callback.cardData.cardCategory +
                //         ', ccBin: ' +
                //         callback.cardData.ccBin +
                //         ', issuing bank: ' +
                //         callback.cardData.ccIssuingBank +
                //         ' and fraudSessionId: ' +
                //         fraudSessionId +
                //         ', after that I can call final submit'
                // );
                setIsLoading(true);
                procClientContinue(
                    firstName + '\n' + lastName + '\n' + zip + '\n' + email + '\n' + mobile + '\n'
                );
            } else {
                //* TODO: do we want to log the errors? */

                // const errorArray = callback.error;
                // for (const i in errorArray) {
                //     console.log(
                //         'Received error: tagId= ' +
                //             errorArray[i].tagId +
                //             ', errorCode= ' +
                //             errorArray[i].errorCode +
                //             ', errorDescription= ' +
                //             errorArray[i].errorDescription
                //     );
                // }
                setIsSubmitted(false);
                setIsError(true);
            }
        });
    };

    return (
        <div>
            <Flex justifyContent="space-between" componentClasses={styles.formRow}>
                <Input
                    placeholder="Enter your name…"
                    label="First name"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    componentClasses={styles.halfRow}
                    size="large"
                />
                <Input
                    placeholder="Enter your last name…"
                    label="Last name"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    componentClasses={styles.halfRow}
                    size="large"
                />
            </Flex>
            <Flex direction="column" alignItems="flex-start" componentClasses={styles.formRow}>
                <label htmlFor="card-number" className={styles.bluesnapLabel}>
                    Credit Card No.
                </label>
                <Flex
                    componentClasses={
                        ccnStatus.length > 0 ? styles.bluesnapInputError : styles.bluesnapInput
                    }
                >
                    <div id="card-number" data-bluesnap="ccn"></div>
                    <div className={styles.cardImg}>
                        <img src={getCardPicByType(cardType)} alt={cardType} />
                    </div>
                </Flex>
                {ccnStatus.length > 0 && (
                    <Text skin="tiny" textColor="red">
                        {ccnStatus}
                    </Text>
                )}
            </Flex>
            <Flex>
                <Flex direction="column" alignItems="flex-start" componentClasses={styles.halfRow}>
                    <label htmlFor="exp-date" className={styles.bluesnapLabel}>
                        Expiry Date
                    </label>
                    <div
                        id="exp-date"
                        data-bluesnap="exp"
                        className={
                            expStatus.length > 0 ? styles.bluesnapInputError : styles.bluesnapInput
                        }
                    ></div>
                </Flex>
                <Flex direction="column" alignItems="flex-start" componentClasses={styles.halfRow}>
                    <label htmlFor="cvv" className={styles.bluesnapLabel}>
                        Security Code
                    </label>
                    <div
                        id="cvv"
                        data-bluesnap="cvv"
                        className={
                            cvvStatus.length > 0 ? styles.bluesnapInputError : styles.bluesnapInput
                        }
                    ></div>
                </Flex>
            </Flex>
            <Flex justifyContent="space-between" componentClasses={styles.formRow}>
                <div className={styles.halfRow}>
                    {expStatus.length > 0 && (
                        <Text skin="tiny" textColor="red">
                            {expStatus}
                        </Text>
                    )}
                </div>
                <div className={styles.halfRow}>
                    {cvvStatus.length > 0 && (
                        <Text skin="tiny" textColor="red">
                            {cvvStatus}
                        </Text>
                    )}
                </div>
            </Flex>
            <Flex justifyContent="space-between" componentClasses={styles.formRow}>
                <Input
                    placeholder="(123) 123-1234"
                    label="Cell Phone No."
                    value={mobile}
                    onChange={e => setMobile(e.target.value)}
                    componentClasses={styles.halfRow}
                    size="large"
                />
                <Input
                    placeholder="12345"
                    label="Zip Code"
                    value={zip}
                    onChange={e => setZip(e.target.value)}
                    componentClasses={styles.halfRow}
                    size="large"
                />
            </Flex>
            <Flex direction="column" componentClasses={styles.formRow}>
                <Input
                    placeholder="email@youremail.com"
                    label="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    size="large"
                />
            </Flex>
            <Footer
                isPayment={isPayment.current}
                total={total}
                submitPayment={submitPayment}
                isPaymentButtonDisabled={isPaymentButtonDisabled()}
                isBankTransfer={false}
            />
        </div>
    );
};
